import { Button, Grid, Typography } from "@mui/material"
import OneModal from "../../OneModal/OneModal"
import OneTextArea from "../../OneTextArea/OneTextArea"
import OneSelect from "../../OneSelect/OneSelect"
import { tempoDesligar } from "../../../Utils/optionsSelects"

const ModalObservacao = ({ open, setOpen, onClickButton, texto, onChangeText, horaFecha, sethoraFecha, manterAberto, setmanterAberto, obsOn, horaOn }) => {
    const validaDisabled = () => {
        if (obsOn && horaOn) {
            if (texto.length > 5 && horaFecha != '0') {
                return false
            }
            return true
        } else if (!obsOn && horaOn) {
            if (horaFecha != '0') {
                return false
            }
            return true
        } else if (obsOn && !horaOn) {
            if (texto.length >= 5) {
                return false
            }
            return true
        }
        return true
    }
    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText={'Manter Aberto'}
            height={obsOn ? '45%' : '23%' }
            width="40%"
        >
            <Grid container >
                <Grid width={'100%'} height={'100%'} >
                    <Grid display={obsOn ? 'block' : 'none' } sx={{ display: "flex", alignItems: 'flex-end', justifyContent: "space-between", width: '100%', height: '5%', margin: '5px' }}>
                        <Typography display={obsOn ? 'block' : 'none' }>Observação: </Typography>
                        {
                            texto.length < 5 ? <Typography display={obsOn ? 'block' : 'none' } sx={{ color: 'red', marginRight: '5px' }}>Min. de 5 caracteres </Typography> : ''
                        }
                    </Grid>
                    <Grid width={'100%'} height={'45%'} display={obsOn ? 'block' : 'none' } >
                        <OneTextArea
                            onChange={onChangeText}
                            defaultValue={texto}
                            contador={true}
                            maxlength={255}
                            autoFocus
                        />
                    </Grid>
                    <Grid width={'100%'} height={'40%'} marginTop={obsOn ? '5%' : '' }>
                        <Typography>Tempo p/ Desligar:</Typography>
                        <OneSelect
                            options={tempoDesligar}
                            defaultValue={tempoDesligar[0].id}
                            name="tempoDesligar"
                            onChange={ (e) => { sethoraFecha(e.target.value) } }
                        />
                    </Grid>
                    <Grid display={"flex"} justifyContent={"end"} marginTop={obsOn ? '-8%' : '5%' }>
                        <Button
                            onClick={onClickButton}
                            disabled={validaDisabled(texto, horaFecha)}
                            color="one_primary"
                            variant="contained"
                        >Ativar manter aberto</Button>
                    </Grid>
                </Grid>
            </Grid>
        </OneModal>
    )
}
export default ModalObservacao
